import { createContext, useContext, useState, useEffect } from "react";

const RiskProfileContext = createContext(null);

export function RiskProfileProvider({ children }) {
  const [riskProfile, setRiskProfile] = useState(() => {
    if (typeof window === "undefined") return "balanced";
    return localStorage.getItem("riskProfile") || "balanced";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("riskProfile", riskProfile);
    }
  }, [riskProfile]);

  return (
    <RiskProfileContext.Provider value={{ riskProfile, setRiskProfile }}>
      {children}
    </RiskProfileContext.Provider>
  );
}

export function useRiskProfile() {
  const context = useContext(RiskProfileContext);
  if (!context) {
    throw new Error("useRiskProfile must be used within RiskProfileProvider");
  }
  return context;
}
